import { type MultiPackProduct, type ProductPriceType } from "@jti/fe-common";
import type { ApiMagentoPriceTier } from "@jti/magento-types";
import { FormattedPrice } from "@jti/ui/components/FormattedPrice";

import { ProductDetailsCtaLayout } from "../ProductDetailsCtaLayout";
import { ProductDetailsCtaMobileProductData } from "../ProductDetailsCtaMobileProductData";
import { ProductMultipacks } from "../ProductMultipacks";
import { ProductMultiplier } from "../ProductMultiplier";

type AddToCartButtonWrapperProps = React.PropsWithChildren<{
  children: React.ReactNode;
  name: string;
  sku: string;
  multiPackDescription: string;
  multiPackName: string;
  multiPackProducts: MultiPackProduct[];
  shouldRenderPrice?: boolean;
  hideCta?: boolean;
  isMultiPackEnabled: boolean;
  priceInformation?: ProductPriceType | null;
  priceTiers?: ApiMagentoPriceTier[];
}>;

// This component should not have a business logic. Ideally consumers of this component should use ProductDetailsCtaLayout right away.
const AddToCartButtonWrapper: React.FC<AddToCartButtonWrapperProps> = ({
  children,
  name,
  sku,
  multiPackDescription,
  multiPackName,
  multiPackProducts,
  shouldRenderPrice,
  hideCta = false,
  isMultiPackEnabled,
  priceInformation,
  priceTiers = [],
}) => {
  if (hideCta) {
    return null;
  }

  return (
    <ProductDetailsCtaLayout
      mobileCtaContent={
        <ProductDetailsCtaMobileProductData
          productName={name}
          productPrice={
            priceInformation?.finalPrice !== undefined && shouldRenderPrice ? (
              <FormattedPrice {...priceInformation.finalPrice} />
            ) : null
          }
        />
      }
    >
      {priceTiers.length > 1 ? (
        <ProductMultiplier priceTiers={priceTiers} />
      ) : (
        <ProductMultipacks
          isMultiPackEnabled={isMultiPackEnabled}
          currentProduct={{ sku, name, multiPackName, multiPackDescription }}
          multiPackProducts={multiPackProducts}
        />
      )}
      {children}
    </ProductDetailsCtaLayout>
  );
};

export default AddToCartButtonWrapper;
